import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useBuilderRunNowResultsLogic } from 'shared-modules/services/hooks/builder';
import RunAllFail from '../RunAutoTradeComponents/RunAllFail';

const BuilderAddToPortfolioFail = ({ isOpen, closeModal, orderName, fullErrorText }) => {
  const runNowResultsLogic = useBuilderRunNowResultsLogic({ orderName, closeModal, fullErrorText });

  return (
    <RunAllFail
      isOpen={isOpen}
      closeModal={closeModal}
      title={runNowResultsLogic.fail.modalTitle}
      info={[runNowResultsLogic.fail.info]}
    />
  );
};

BuilderAddToPortfolioFail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  orderName: PropTypes.string.isRequired,
  fullErrorText: PropTypes.string.isRequired,
};

export default memo(BuilderAddToPortfolioFail);
